// extracted by mini-css-extract-plugin
export default {"wrapper":"RentTypeToggle_wrapper__d9Zq8","slider":"RentTypeToggle_slider__vPdNn","btn":"RentTypeToggle_btn__iq3tN","activeText":"RentTypeToggle_activeText__bLWKF"};